/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: cidModifiersActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteCidModifier } from './api/cidModifierApi';

/**
 * Shared helpers for CID Modifiers module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a CID Modifier in the form.
 * Pattern: /pbx/incoming-tools/cid-modifiers/new?duplicate={id}
 */
export const getCidModifierDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/cid-modifiers/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given CID Modifier id.
 */
export const navigateToCidModifierDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getCidModifierDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a CID Modifier by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteCidModifierById = async (id: string | number): Promise<void> => {
  await deleteCidModifier(id);
};

